import { toast } from "react-toastify";
export const showToastMessage = (messageType, message) => {
  return toast(message, {
    position: "top-right",
    autoClose: 8000,
    limit:2,
    newestOnTop:false,
    hideProgressBar:false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
